import React from 'react';
import type { EntryPointComponent } from 'react-relay';
import { SummaryStateContainer } from '@atlassian/jira-issue-smart-request-summary-state/src/ui/index.tsx';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';
import { Summary } from './ui/index.tsx';

export const SmartRequestSummary: EntryPointComponent<{}, {}, {}, {}> = () => (
	<ContextualAnalyticsData sourceName="smartRequestSummary" sourceType={SCREEN}>
		<SummaryStateContainer>
			<Summary />
		</SummaryStateContainer>
	</ContextualAnalyticsData>
);
